import * as React from 'react';
import * as styles from './styles.css';
import { UIText1 } from '@cian/ui-kit';

export type ProcessTabId = 'sale' | 'buy';

export interface IProcessStep {
  icon: string;
  title: string;
  content: React.ReactNode;
  note?: React.ReactNode;
  isFull?: boolean;
}

export interface IProcessAccordionItem {
  title: string;
  text: string;
  image: string;
}

export interface IProcessSectionProps {
  steps: IProcessStep[];
  saleItems: IProcessAccordionItem[];
  buyItems: IProcessAccordionItem[];
  isTabActive: (tabId: ProcessTabId) => boolean;
  onTabChange: (tabId: ProcessTabId) => void;
  saleIsOpen: (index: number) => boolean;
  onSaleToggle: (index: number) => void;
  buyIsOpen: (index: number) => boolean;
  onBuyToggle: (index: number) => void;
}

export const ProcessSection: React.FC<IProcessSectionProps> = ({
  steps,
  saleItems,
  buyItems,
  isTabActive,
  onTabChange,
  saleIsOpen,
  onSaleToggle,
  buyIsOpen,
  onBuyToggle,
}) => (
  <section className={`${styles['process-section']} reveal`} aria-label="Как работает сервис">
    <div className={styles['process']}>
      <h2 className={styles['process__title']}>Как работает сервис</h2>

      <div className={styles['process__steps']}>
        {steps.map((step, index) => (
          <div
            key={step.title}
            className={
              step.isFull ? `${styles['process-step']} ${styles['process-step--full']}` : styles['process-step']
            }
          >
            <div className={styles['process-step__icon']} aria-hidden="true">
              <img src={step.icon} alt="" />
            </div>
            <div className={styles['process-step__content']}>
              <h3>{step.title}</h3>
              {step.content != null && (
                <span className="body1">
                  <UIText1 color="text-inverted-default">{step.content}</UIText1>
                </span>
              )}
              {step.note != null && <h6 className={styles['process-step__note']}>{step.note}</h6>}
              {index === 2 && (
                <>
                  <div className={styles['tabs']} data-tabs>
                    <button
                      className={`${styles['tabs__button']} ${isTabActive('sale') ? 'is-active' : ''}`}
                      type="button"
                      onClick={() => onTabChange('sale')}
                      data-tab-button="sale"
                    >
                      Продажа
                    </button>
                    <button
                      className={`${styles['tabs__button']} ${isTabActive('buy') ? 'is-active' : ''}`}
                      type="button"
                      onClick={() => onTabChange('buy')}
                      data-tab-button="buy"
                    >
                      Покупка
                    </button>
                  </div>

                  <div
                    className={`${styles['accordion']} ${isTabActive('sale') ? 'is-active' : ''}`}
                    data-tab-panel="sale"
                  >
                    {saleItems.map((item, i) => (
                      <div
                        key={item.title}
                        className={`${styles['accordion__item']} ${saleIsOpen(i) ? 'is-open' : ''}`}
                      >
                        <button
                          className={styles['accordion__toggle']}
                          type="button"
                          onClick={() => onSaleToggle(i)}
                          data-accordion-toggle
                        >
                          <span className={styles['accordion__title']}>{item.title}</span>
                        </button>
                        <div className={styles['accordion__panel']}>
                          <span className="body1">
                            <UIText1 color="text-inverted-default">{item.text}</UIText1>
                          </span>
                          <img className={styles['accordion__image']} src={item.image} alt="" />
                        </div>
                      </div>
                    ))}
                  </div>

                  <div
                    className={`${styles['accordion']} ${isTabActive('buy') ? 'is-active' : ''}`}
                    data-tab-panel="buy"
                  >
                    {buyItems.map((item, i) => (
                      <div key={item.title} className={`${styles['accordion__item']} ${buyIsOpen(i) ? 'is-open' : ''}`}>
                        <button
                          className={styles['accordion__toggle']}
                          type="button"
                          onClick={() => onBuyToggle(i)}
                          data-accordion-toggle
                        >
                          <span className={styles['accordion__title']}>{item.title}</span>
                        </button>
                        <div className={styles['accordion__panel']}>
                          <span className="body1">
                            <UIText1 color="text-inverted-default">{item.text}</UIText1>
                          </span>
                          <img className={styles['accordion__image']} src={item.image} alt="" />
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
